import { z } from 'zod';
export const numberOptionsSchema = z.object({
    unit: z.string().optional().describe('Unit for display: kg, km, mph, etc.'),
});
export const numberCellSchema = z.number();
//# sourceMappingURL=number.js.map